import React from 'react'
import AnalyticsDashboard from '../../components/features/analytics/AnalyticsDashboard'

export const AnalyticsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <AnalyticsDashboard />
    </div>
  )
}